export default "__VITE_ASSET__6e62920a__"